const FndUserOrgFields = [
    {
        name: '组织名称',
        code: 'roleName',
        column: true,
        defaultFilter: true,
        width: 300
    },
    {
        name: '组织路径',
        code: 'roleCode',
        column: true,
        defaultFilter: true,
    }
]
export default FndUserOrgFields;